// extracted by mini-css-extract-plugin
export default {"emptyText":"List_emptyText__jb2x8"};